module.exports = {
  color: {
    base: {
      white: '#fff',
      black: '#000',
      textPrimary: '#111827',
      textSecondary: '#000',
    },
    brand: {
      primary: '#91B122',
      background: '#334656',
      backgroundHover: '#425769',
    },
    action: {
      create: '#DD862C',
      bulkDelete: '#C4414B',
      delete: '#76B8CC',
      cancel: '#88898B',
      destructive: '#dc2626',
    },
    state: {
      enabled: '#F8CB35',
      preview: '#ffebcd',
      disabled: '#E5E7EB',
    },
    gray: {
      button: '#6D7477',
      inactive: '#b8c0cc',
      muted: '#888',
      surface: '#E8E8E8',
      surfaceHover: '#f5f4f0',
      surfaceSearch: '#f5f6f7',
      border: '#d1d5db',
      borderMuted: '#d5d7da',
    },
    favorite: {
      active: '#f6c945',
      link: '#e9c502',
    },
    misc: {
      customDarkGray: '#333333',
      customPaleBlue: '#47559E',
      customVividRed: '#ED1119',
      customPaleYellow: '#FFFFE9',
      customDarkYellow: '#ffdf3d',
    },
    hazardMap: {
      tag: '#EB6A0C',
      list: '#F48C40',
    },
    usageGuideFlood: {
      palePink: '#FF9FA0',
      lightPink: '#FDC0C0',
      paleOrange: '#FFCE97',
      paleYellow: '#FFFA80',
    },
    usageGuideReservoir: {
      vividRed: '#EE3239',
      vividCoral: '#F0664D',
      palePeach: '#FBC7C2',
      paleYellow: '#F3EF92',
    },
    usageSedimentDisaster: {
      vividOrange: '#ED6D46',
      vividYellow: '#FBDA09',
      paleYellow: '#FFE99D',
      vividBrown: '#973E22',
      paleBeige: '#EDCBAB',
    },
    spotStatus: {
      open: '#334656',
      preparation: '#617481',
    },
    information: {
      darkGreen: '#7B9A0F',
      dimGray: '#727272',
    },
    tenant: {
      taiji: {
        signage: {
          customDarkBlue: '#334656',
          customDarkGreen: '#91B122',
          customDarkPink: '#C9447C',
        },
        usageGuide: {
          paleGreen: '#76D68C',
          darkYellow: '#E5AC13',
          paleBlue: '#2E9AD7',
          darkOrange: '#FF7F50',
        },
      },
      otari: {
        usageGuide: {
          darkYellow: '#FFD351',
        },
      },
      shirahama: {
        signage: {
          customDarkGreen: '#93B225',
        },
      },
      toyonaka: {
        hazard: {
          naisui: {
            '1-3': '#F8A488',
            '05-1': '#FBC2AD',
            '03-05': '#FFF56D',
            '005-03': '#E7EFC1',
          },
        },
        waterSupply: {
          mainBlue: '#2E9AD7',
        },
      },
    },
  },
};
